<template>
  <div
    v-if="breadcrumb"
    class="breadcrumb"
    :class="classes"
  >
    <ul>
      <li v-for="(item, i) in breadcrumb" :key="i">
        <span v-if="$route.fullPath === item.slug">
          {{ item.name }}
        </span>
        <nuxt-link
          v-else-if="item.slug.length"
          :to="item.slug"
        >
          {{ item.name }}
        </nuxt-link>
        <span
          v-if="!item.slug.length"
        >
          {{ item.name }}
        </span>
        <CaretRight v-if="item.slug.length" />
      </li>
    </ul>
  </div>
</template>

<script>
import CaretRight from '../assets/svg/caret-right.svg?vue-component';

export default {
  components: { CaretRight },
  props: {
    classes: { type: String, default: () => '', required: false },
    breadcrumb: { type: Array, default: () => [], required: false },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb {
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: inline-block;

    li {
      float: left;

      a,
      span {
        font-weight: 500;
        font-size: 14px;
        line-height: 130%;
        letter-spacing: 0.02em;
        text-transform: capitalize;
        color: var(--main-dark-shade-0);
      }

      a {
        color: var(--main-dark-shade-0);
      }

      span {
        color: var(--main-dark-shade-3);
      }
    }

    svg {
      transform: rotate(180deg);
      vertical-align: middle;
      margin: 0 10px;
      width: 12px;
      height: 12px;

      path[stroke] {
        stroke: var(--main-dark);
      }
    }

    @include bp($bp-mobile) {
      svg {
        margin: 0 5px;
      }
    }
  }

  &.light {
    ul {
      li a {
        color: var(--main-dark-shade-4);
      }

      svg path[stroke] {
        stroke: var(--main-dark-shade-3);
      }
    }
  }

  &.scrollable {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    position: relative;

    ul {
      display: flex;
      flex-direction: row;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.fa {
  .breadcrumb ul {
    li {
      a {
        color: var(--main-dark-shade-0);
      }

      span {
        color: var(--main-dark-light-4);
      }
    }

    svg path[stroke] {
      stroke: var(--main-dark-shade-0);
    }
  }
}
</style>
